<!-- Error page-->
<div class="misc-wrapper">
	<a class="brand-logo" href="javascript:void(0);">
		<!-- <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" /> -->
		<h2 class="brand-text text-primary ml-1" style="font-family: 'Montserrat', Helvetica, Arial, serif !important">Grupo 2E</h2>
	</a>
	<div class="misc-inner p-2 p-sm-3">
		<div class="w-100 text-center">
			<h2 class="mb-1">Página não encontrada</h2>
			<p class="mb-2">A url requisitada não foi encontrada.</p>
			<a class="btn btn-primary mb-2 btn-sm-block" routerLink="/" rippleEffect>Voltar para o Início</a><img
				class="img-fluid" [src]="
          coreConfig.layout.skin === 'dark' ? 'assets/images/pages/error-dark.svg' : 'assets/images/pages/error.svg'
        " alt="Error page" />
		</div>
	</div>
</div>
<!-- / Error page-->